<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<!-- custom ui-->
<div *ngIf="customContent?.templateRef" (click)="fileInput.click()" class="custom-content-wrapper">
	<ng-container [ngTemplateOutlet]="customContent.templateRef"></ng-container>
</div>

<!-- standard ui (expecting to be wrapped in a mat-form-field) -->
<ng-container *ngIf="!customContent?.templateRef">
	<div class="upload-container">
		<input
			#stdInput
			class="upload-input-field"
			matInput
			[formControl]="uploadedFilenames"
			(click)="fileInput.click()"
			(focusin)="onFocusIn($event)"
			(focusout)="onFocusOut($event)"
			automationId="ticketDataFile"
			autocomplete="off"
			spellcheck="false"
		/>

		<div class="upload-button">
			<button
				type="button"
				mat-stroked-button
				color="primary"
				automationId="uploadButton"
				[disabled]="disabled"
				(click)="fileInput.click()"
			>
				{{ buttonText | uppercase }}
			</button>
		</div>
	</div>
</ng-container>

<!-- actual file input/upload, invisible -->
<input
	#fileInput
	type="file"
	class="file-upload"
	automationId="fileUpload"
	accept="{{ acceptedFileTypes.join() }}"
	[attr.multiple]="allowMultiple ? 'multiple' : null"
	(change)="onFileChange($event)"
/>
